import {
  WHERE,
  WHEN,
  CONTACT,
  QUESTIONS,
  CONFIRMATION,
  selectScheduleTourStep,
} from 'src/store/slices/scheduleTour'
import { useSelector } from 'react-redux'
import Where from './Where'
import When from './When'
import { Contact } from './Contact/Contact'
import { Questions } from './Questions/Questions'
import Confirmation from './Confirmation'

const ScheduleTourModalSteps = () => {
  const currentStep = useSelector(selectScheduleTourStep)

  return (
    <>
      {currentStep === WHERE && <Where />}
      {currentStep === WHEN && <When />}
      {currentStep === CONTACT && <Contact />}
      {currentStep === QUESTIONS && <Questions />}
      {currentStep === CONFIRMATION && <Confirmation />}
    </>
  )
}

export default ScheduleTourModalSteps
